export function debounce<T extends (...args: any[]) => void>(
  func: T,
  wait: number,
): (...args: Parameters<T>) => void {
  let timeout: ReturnType<typeof setTimeout>;

  return (...args: Parameters<T>): void => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
}

// Example usage:
const myFunction = (message: string) => {
  console.log(message);
};

const debouncedFunction = debounce(myFunction, 1000);

debouncedFunction('Hello');
debouncedFunction('Hello again'); // Only this call will actually execute myFunction after 1 second
